import { render, staticRenderFns } from "./TechPage.vue?vue&type=template&id=07ae24d3&scoped=true"
import script from "./TechPage.vue?vue&type=script&lang=js"
export * from "./TechPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=07ae24d3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae24d3",
  null
  
)

export default component.exports